import { PayloadAction } from "@reduxjs/toolkit";
import { IInitialState, IYearsList } from "./Types";

export const Reducer = {
  setFinancialYear: (state: IInitialState, action: PayloadAction<IYearsList[]>): void => {
    state.yearsList = action.payload;
  },
  selectedYear: (state: IInitialState, action: PayloadAction<string>): void => {
    state.selectedYear = action.payload;
  },
  setCollapsedView: (state: IInitialState, action: PayloadAction<boolean>): void => {
    state.isCollapsedView = action.payload;
  }
};
